import { AppNews } from '@/model/AppNews';
import { CRUD } from './base/crud';

class AppNewsService extends CRUD<AppNews, any> {
    readonly endPoint = 'admin/app-news';
}

export const appNewsService = new AppNewsService();
